export default __webpack_public_path__ + "static/media/purple ribbon.9733916f.svg";